import React, { useEffect } from 'react';
import { Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useCategoryStrings } from './constants/useCategoryStrings';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme =>
  createStyles({
    categoryView: {
      marginTop: theme.spacing(1),
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
    },

    attributeItem: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
);

interface CategorySheetViewProps {
  productSheet: any;
}

export default function CommodityCategoryView({
  productSheet,
}: CategorySheetViewProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const CategoryStrings = useCategoryStrings();
  const commodity = useSelector(
    (state: RootStateOrAny) => state.CommodityGroupsReducer?.commodity,
  );

  return (
    <div className={classes.categoryView}>
      <div className={classes.attributeItem}>
        <Typography variant="h6">{CategoryStrings.is_parent}</Typography>
        {productSheet?.isParent ? <CheckIcon /> : <CloseIcon />}
      </div>
      <div>
        <Typography variant="h6">{CategoryStrings.category}</Typography>
        <Typography variant="body2">
          {productSheet?.isParent
            ? commodity?.psGroupData?.PsBaseName || 'Not defined'
            : productSheet?.category?.name ||
              commodity?.categoryName ||
              'Not defined'}
        </Typography>
      </div>
      {!productSheet?.isParent && (
        <div>
          <Typography variant="h6">{CategoryStrings.subcategory}</Typography>
          <Typography variant="body2">
            {commodity?.subCategoryName || 'Not defined'}
          </Typography>
        </div>
      )}
      <div>
        <Typography variant="h6">
          {t(
            'commodity.viewDetails.production_id',
            CategoryStrings.production_id,
          )}
        </Typography>
        <Typography variant="body2">
          {commodity?.psGroupData?.friendlyNameGroupId || 'Not defined'}
        </Typography>
      </div>
    </div>
  );
}
